// hooks/useOneTimeHelper.ts
import { useEffect, useState } from "react";
import { useHelperTipStore } from "@/store/helperTips";

export function useOneTimeHelper(key: string, delay: number = 1000) {
  const [showHelper, setShowHelper] = useState(false);
  const dismiss = useHelperTipStore((s) => s.dismiss);
  const isDismissed = useHelperTipStore((s) => s.isDismissed(key));

  useEffect(() => {
    if (isDismissed) {
      setShowHelper(false);
    } else {
      const timer = setTimeout(() => {
        if (!isDismissed) setShowHelper(true);
      }, delay);
      return () => clearTimeout(timer);
    }
  }, [key, delay, isDismissed]);

  const dismissHelper = () => {
    dismiss(key);
    setShowHelper(false);
  };

  return { showHelper, dismissHelper };
}
